import { create } from "zustand";
import { ApplicationItem, ApplicationMeta, ApplicationStatus, StatusCounts } from "../types/application";

const BASE_URL = "https://admin.talentlinkindo.com/api/candidate/my-applications/filter";

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch {
    return null;
  }
};

type UserApplicationsState = {
  activeTab: ApplicationStatus;
  page: number;
  loading: boolean;

  data: Record<ApplicationStatus, ApplicationItem[]>;
  meta: Partial<Record<ApplicationStatus, ApplicationMeta>>;
  counts: StatusCounts | null;

  setActiveTab: (tab: ApplicationStatus) => void;
  setPage: (page: number) => void;

  fetchApplications: (status: ApplicationStatus) => Promise<void>;
};

export const useUserApplicationsStore = create<UserApplicationsState>((set, get) => ({
  activeTab: "applied",
  page: 1,
  loading: false,

  data: {
    applied: [],
    reviewed: [],
    interviewed: [],
    hired: [],
    rejected: [],
  },

  meta: {},
  counts: null,

  setActiveTab: (tab) =>
    set({
      activeTab: tab,
      page: 1,
    }),

  setPage: (page) => set({ page }),

  fetchApplications: async (status) => {
    const token = getAccessToken();
    if (!token) return;

    const { page } = get();

    set({ loading: true });

    try {
      const res = await fetch(`${BASE_URL}/${status}?page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const json = await res.json();

      set((state) => ({
        data: {
          ...state.data,
          [status]: json.data,
        },
        meta: {
          ...state.meta,
          [status]: {
            current_page: json.meta.current_page,
            last_page: json.meta.last_page,
            total: json.meta.total,
            per_page: json.meta.per_page,
          },
        },
        counts: json.status_counts,
        loading: false,
      }));
    } catch (e) {
      console.error("❌ Fetch applications failed", e);
      set({ loading: false });
    }
  },
}));
